export const events = {
  watchFirstStepsVideo: 'Watch first steps video',
  openHelpWidget: 'Open Help widget',
  closeHelpWidget: 'Close Help widget',
  goToQuickTourOfFactorial: 'Go to Quick tour of Factorial video',
  goToVideoTutorials: 'Go to video tutorials',
  openedVideoTutorial: 'Opened a video tutorial',
  sendLearningCardFeedback: 'Send learning card feedback',
  requestToContact: 'Request to contact',
  requestCall: 'Request a call',
  openHubspotChat: 'Open HubSpot chat',
  openHubspotMeetings: 'Open Hubspot meetings calendar',
  openCallbox: 'Open CallBox',
  goToHelpCenterLink: 'Go to Help Center Link',
  openProductUpdates: 'Open to Product Updates',
}
